<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Especialidades"
    >
        <Form 
            :especialidade="especialidadeSelecionada"
            :regulador="regulador"
            @especialidadeUpdate="especialidadeUpdate($event)"
            ref="Form"
        />

        <List
            :data="data"
            :regulador="regulador"
            @especialidade="especialidade($event)"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalRegulador: null,
        regulador: null,
        especialidadeSelecionada: null,
    }),
    methods: {
        especialidade(especialidade) {

            this.especialidadeSelecionada = especialidade
        },
        open(regulador) {

            this.especialidadeSelecionada = null
            this.originalRegulador = regulador
            this.regulador = this.clone(regulador)

            this.$refs.Modal.show()
        },
        save() {

            this.originalRegulador.especialidades = this.regulador.especialidades

            this.close()
        },
        close() {

            this.especialidadeSelecionada = null
            this.$refs.Modal.hide()
        },
        especialidadeUpdate(especialidade) {

            const index = this.regulador.especialidades.findIndex(e => e.id === especialidade.id)

            if (index !== -1) {
                
                this.regulador.especialidades[index].exigeDocumentoAnexo = especialidade.exigeDocumentoAnexo
            }
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>